import { shipmentStatus } from '@locales/id/labels';
import type { ShipmentStatus } from '@lib/api';
import { Chip } from '@ui';

/** Surat Jalan status; `missing` = cylinders that did not arrive; `short` gives the compact chip ("Selisih 2", "Di jalan"). */
export function ShipmentChip({ status, missing, short }: { status: ShipmentStatus; missing: number; short?: boolean }) {
  const st = shipmentStatus(status, missing, short);
  return <Chip tone={st.tone}>{st.label}</Chip>;
}
